var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFylla2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4844,
    height: 58,
    viewBox: "0 0 4844 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.131 54.1835V57.9622H635.904V58H648.779L612.342 0H599.467L604.441 9.40929H579.569V13.1881H606.649L632.487 54.1835H603.131Z",
    fill: "#F42272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545.26 58L533.168 17.8574L581.428 58H597.229L533.168 7.76883V0H520.644V10.799L529.342 58H545.26Z",
    fill: "#F42272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M474.191 3.77878L510.628 58H523.503L487.066 0H441.417V3.77878H474.191Z",
    fill: "#F42272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M422.64 3.77878L459.078 58H471.953L435.515 0H389.867V3.77878H422.64Z",
    fill: "#F42272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.782 0H313.736L378.851 58H391.726L383.964 0H369.918L367.919 7.51984H337.028L327.782 0ZM367.919 11.2987L374.876 39.3892L341.593 11.2987H367.919Z",
    fill: "#F42272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.133 54.1835V57.9622H322.906V58H335.781L299.344 2.56267e-06H286.469L291.443 9.40929H266.571V13.1881H293.651L319.489 54.1835H290.133Z",
    fill: "#F42272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.262 58L220.17 17.8574L268.429 58H284.231L220.17 7.76883V2.56267e-06H207.646V10.799L216.344 58H232.262Z",
    fill: "#F42272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 3.77878L197.63 58H210.505L174.068 2.56267e-06H128.419V3.77878H161.192Z",
    fill: "#F42272"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.642 3.77878L146.08 58H158.955L122.517 2.56267e-06H76.8691V3.77878H109.642Z",
    fill: "#F42272"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7838 2.56267e-06H0.738281L65.8532 58H78.7283L70.9665 2.56267e-06H56.9207L54.9214 7.51984H24.0307L14.7838 2.56267e-06ZM54.9214 11.2987L61.878 39.3892L28.5955 11.2987H54.9214Z",
    fill: "#F42272"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M923.352 54.1835V57.9622H956.125V58H969L932.563 0H919.688L924.661 9.40929H899.79V13.1881H926.87L952.708 54.1835H923.352Z",
    fill: "#F42272"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M865.481 58L853.389 17.8574L901.648 58H917.449L853.389 7.76883V0H840.865V10.799L849.563 58H865.481Z",
    fill: "#F42272"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M794.411 3.77878L830.849 58H843.724L807.286 0H761.638V3.77878H794.411Z",
    fill: "#F42272"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M742.861 3.77878L779.298 58H792.174L755.736 0H710.088V3.77878H742.861Z",
    fill: "#F42272"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M648.002 0H633.957L699.072 58H711.947L704.185 0H690.139L688.14 7.51984H657.249L648.002 0ZM688.14 11.2987L695.096 39.3892L661.814 11.2987H688.14Z",
    fill: "#F42272"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1572.13 54.1835V57.9622H1604.9V58H1617.78L1581.34 0H1568.47L1573.44 9.40929H1548.57V13.1881H1575.65L1601.49 54.1835H1572.13Z",
    fill: "#F42272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.26 58L1502.17 17.8574L1550.43 58H1566.23L1502.17 7.76883V0H1489.64V10.799L1498.34 58H1514.26Z",
    fill: "#F42272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.19 3.77878L1479.63 58H1492.5L1456.07 0H1410.42V3.77878H1443.19Z",
    fill: "#F42272"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.64 3.77878L1428.08 58H1440.95L1404.52 0H1358.87V3.77878H1391.64Z",
    fill: "#F42272"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.78 0H1282.74L1347.85 58H1360.73L1352.96 0H1338.92L1336.92 7.51984H1306.03L1296.78 0ZM1336.92 11.2987L1343.88 39.3892L1310.59 11.2987H1336.92Z",
    fill: "#F42272"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.13 54.1835V57.9622H1291.91V58H1304.78L1268.34 2.56267e-06H1255.47L1260.44 9.40929H1235.57V13.1881H1262.65L1288.49 54.1835H1259.13Z",
    fill: "#F42272"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.26 58L1189.17 17.8574L1237.43 58H1253.23L1189.17 7.76883V2.56267e-06H1176.65V10.799L1185.34 58H1201.26Z",
    fill: "#F42272"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.19 3.77878L1166.63 58H1179.51L1143.07 2.56267e-06H1097.42V3.77878H1130.19Z",
    fill: "#F42272"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.64 3.77878L1115.08 58H1127.96L1091.52 2.56267e-06H1045.87V3.77878H1078.64Z",
    fill: "#F42272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M983.784 2.56267e-06H969.738L1034.85 58H1047.73L1039.97 2.56267e-06H1025.92L1023.92 7.51984H993.031L983.784 2.56267e-06ZM1023.92 11.2987L1030.88 39.3892L997.596 11.2987H1023.92Z",
    fill: "#F42272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1892.35 54.1835V57.9622H1925.13V58H1938L1901.56 0H1888.69L1893.66 9.40929H1868.79V13.1881H1895.87L1921.71 54.1835H1892.35Z",
    fill: "#F42272"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1834.48 58L1822.39 17.8574L1870.65 58H1886.45L1822.39 7.76883V0H1809.87V10.799L1818.56 58H1834.48Z",
    fill: "#F42272"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.41 3.77878L1799.85 58H1812.72L1776.29 0H1730.64V3.77878H1763.41Z",
    fill: "#F42272"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1711.86 3.77878L1748.3 58H1761.17L1724.74 0H1679.09V3.77878H1711.86Z",
    fill: "#F42272"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1617 0H1602.96L1668.07 58H1680.95L1673.19 0H1659.14L1657.14 7.51984H1626.25L1617 0ZM1657.14 11.2987L1664.1 39.3892L1630.81 11.2987H1657.14Z",
    fill: "#F42272"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2542.13 54.1835V57.9622H2574.9V58H2587.78L2551.34 0H2538.47L2543.44 9.40929H2518.57V13.1881H2545.65L2571.49 54.1835H2542.13Z",
    fill: "#F42272"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2484.26 58L2472.17 17.8574L2520.43 58H2536.23L2472.17 7.76883V0H2459.64V10.799L2468.34 58H2484.26Z",
    fill: "#F42272"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2413.19 3.77878L2449.63 58H2462.5L2426.07 0H2380.42V3.77878H2413.19Z",
    fill: "#F42272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2361.64 3.77878L2398.08 58H2410.95L2374.52 0H2328.87V3.77878H2361.64Z",
    fill: "#F42272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2266.78 0H2252.74L2317.85 58H2330.73L2322.96 0H2308.92L2306.92 7.51984H2276.03L2266.78 0ZM2306.92 11.2987L2313.88 39.3892L2280.59 11.2987H2306.92Z",
    fill: "#F42272"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2229.13 54.1835V57.9622H2261.91V58H2274.78L2238.34 2.56267e-06H2225.47L2230.44 9.40929H2205.57V13.1881H2232.65L2258.49 54.1835H2229.13Z",
    fill: "#F42272"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.26 58L2159.17 17.8574L2207.43 58H2223.23L2159.17 7.76883V2.56267e-06H2146.65V10.799L2155.34 58H2171.26Z",
    fill: "#F42272"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2100.19 3.77878L2136.63 58H2149.51L2113.07 2.56267e-06H2067.42V3.77878H2100.19Z",
    fill: "#F42272"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2048.64 3.77878L2085.08 58H2097.96L2061.52 2.56267e-06H2015.87V3.77878H2048.64Z",
    fill: "#F42272"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1953.78 2.56267e-06H1939.74L2004.85 58H2017.73L2009.97 2.56267e-06H1995.92L1993.92 7.51984H1963.03L1953.78 2.56267e-06ZM1993.92 11.2987L2000.88 39.3892L1967.6 11.2987H1993.92Z",
    fill: "#F42272"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2862.35 54.1835V57.9622H2895.13V58H2908L2871.56 0H2858.69L2863.66 9.40929H2838.79V13.1881H2865.87L2891.71 54.1835H2862.35Z",
    fill: "#F42272"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2804.48 58L2792.39 17.8574L2840.65 58H2856.45L2792.39 7.76883V0H2779.87V10.799L2788.56 58H2804.48Z",
    fill: "#F42272"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2733.41 3.77878L2769.85 58H2782.72L2746.29 0H2700.64V3.77878H2733.41Z",
    fill: "#F42272"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2681.86 3.77878L2718.3 58H2731.17L2694.74 0H2649.09V3.77878H2681.86Z",
    fill: "#F42272"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2587 0H2572.96L2638.07 58H2650.95L2643.19 0H2629.14L2627.14 7.51984H2596.25L2587 0ZM2627.14 11.2987L2634.1 39.3892L2600.81 11.2987H2627.14Z",
    fill: "#F42272"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3510.13 54.1835V57.9622H3542.9V58H3555.78L3519.34 0H3506.47L3511.44 9.40929H3486.57V13.1881H3513.65L3539.49 54.1835H3510.13Z",
    fill: "#F42272"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3452.26 58L3440.17 17.8574L3488.43 58H3504.23L3440.17 7.76883V0H3427.64V10.799L3436.34 58H3452.26Z",
    fill: "#F42272"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3381.19 3.77878L3417.63 58H3430.5L3394.07 0H3348.42V3.77878H3381.19Z",
    fill: "#F42272"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3329.64 3.77878L3366.08 58H3378.95L3342.52 0H3296.87V3.77878H3329.64Z",
    fill: "#F42272"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3234.78 0H3220.74L3285.85 58H3298.73L3290.96 0H3276.92L3274.92 7.51984H3244.03L3234.78 0ZM3274.92 11.2987L3281.88 39.3892L3248.59 11.2987H3274.92Z",
    fill: "#F42272"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3197.13 54.1835V57.9622H3229.91V58H3242.78L3206.34 2.56267e-06H3193.47L3198.44 9.40929H3173.57V13.1881H3200.65L3226.49 54.1835H3197.13Z",
    fill: "#F42272"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3139.26 58L3127.17 17.8574L3175.43 58H3191.23L3127.17 7.76883V2.56267e-06H3114.65V10.799L3123.34 58H3139.26Z",
    fill: "#F42272"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3068.19 3.77878L3104.63 58H3117.51L3081.07 2.56267e-06H3035.42V3.77878H3068.19Z",
    fill: "#F42272"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3016.64 3.77878L3053.08 58H3065.96L3029.52 2.56267e-06H2983.87V3.77878H3016.64Z",
    fill: "#F42272"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2921.78 2.56267e-06H2907.74L2972.85 58H2985.73L2977.97 2.56267e-06H2963.92L2961.92 7.51984H2931.03L2921.78 2.56267e-06ZM2961.92 11.2987L2968.88 39.3892L2935.6 11.2987H2961.92Z",
    fill: "#F42272"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3830.35 54.1835V57.9622H3863.13V58H3876L3839.56 0H3826.69L3831.66 9.40929H3806.79V13.1881H3833.87L3859.71 54.1835H3830.35Z",
    fill: "#F42272"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3772.48 58L3760.39 17.8574L3808.65 58H3824.45L3760.39 7.76883V0H3747.87V10.799L3756.56 58H3772.48Z",
    fill: "#F42272"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3701.41 3.77878L3737.85 58H3750.72L3714.29 0H3668.64V3.77878H3701.41Z",
    fill: "#F42272"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3649.86 3.77878L3686.3 58H3699.17L3662.74 0H3617.09V3.77878H3649.86Z",
    fill: "#F42272"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3555 0H3540.96L3606.07 58H3618.95L3611.19 0H3597.14L3595.14 7.51984H3564.25L3555 0ZM3595.14 11.2987L3602.1 39.3892L3568.81 11.2987H3595.14Z",
    fill: "#F42272"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4478.13 54.1835V57.9622H4510.9V58H4523.78L4487.34 0H4474.47L4479.44 9.40929H4454.57V13.1881H4481.65L4507.49 54.1835H4478.13Z",
    fill: "#F42272"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4420.26 58L4408.17 17.8574L4456.43 58H4472.23L4408.17 7.76883V0H4395.64V10.799L4404.34 58H4420.26Z",
    fill: "#F42272"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4349.19 3.77878L4385.63 58H4398.5L4362.07 0H4316.42V3.77878H4349.19Z",
    fill: "#F42272"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4297.64 3.77878L4334.08 58H4346.95L4310.52 0H4264.87V3.77878H4297.64Z",
    fill: "#F42272"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4202.78 0H4188.74L4253.85 58H4266.73L4258.96 0H4244.92L4242.92 7.51984H4212.03L4202.78 0ZM4242.92 11.2987L4249.88 39.3892L4216.59 11.2987H4242.92Z",
    fill: "#F42272"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4165.13 54.1835V57.9622H4197.91V58H4210.78L4174.34 2.56267e-06H4161.47L4166.44 9.40929H4141.57V13.1881H4168.65L4194.49 54.1835H4165.13Z",
    fill: "#F42272"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4107.26 58L4095.17 17.8574L4143.43 58H4159.23L4095.17 7.76883V2.56267e-06H4082.65V10.799L4091.34 58H4107.26Z",
    fill: "#F42272"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4036.19 3.77878L4072.63 58H4085.51L4049.07 2.56267e-06H4003.42V3.77878H4036.19Z",
    fill: "#F42272"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3984.64 3.77878L4021.08 58H4033.96L3997.52 2.56267e-06H3951.87V3.77878H3984.64Z",
    fill: "#F42272"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M3889.78 2.56267e-06H3875.74L3940.85 58H3953.73L3945.97 2.56267e-06H3931.92L3929.92 7.51984H3899.03L3889.78 2.56267e-06ZM3929.92 11.2987L3936.88 39.3892L3903.6 11.2987H3929.92Z",
    fill: "#F42272"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4798.35 54.1835V57.9622H4831.13V58H4844L4807.56 0H4794.69L4799.66 9.40929H4774.79V13.1881H4801.87L4827.71 54.1835H4798.35Z",
    fill: "#F42272"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4740.48 58L4728.39 17.8574L4776.65 58H4792.45L4728.39 7.76883V0H4715.87V10.799L4724.56 58H4740.48Z",
    fill: "#F42272"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M4669.41 3.77878L4705.85 58H4718.72L4682.29 0H4636.64V3.77878H4669.41Z",
    fill: "#F42272"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4617.86 3.77878L4654.3 58H4667.17L4630.74 0H4585.09V3.77878H4617.86Z",
    fill: "#F42272"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M4523 0H4508.96L4574.07 58H4586.95L4579.19 0H4565.14L4563.14 7.51984H4532.25L4523 0ZM4563.14 11.2987L4570.1 39.3892L4536.81 11.2987H4563.14Z",
    fill: "#F42272"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFylla2);
export default __webpack_public_path__ + "static/media/fylla2.a08dc6f1692badf3b3df0c3e1bb9c09e.svg";
export { ForwardRef as ReactComponent };